import React from 'react'
import GenericTable from '../general/generic-table'
import { utilService } from '../../services/util-service'

interface EntityTableProps {
    data: any[]
    onEditClick?: (entity: any) => void
    onCompleteSetupClick?: (entity: any) => void
}

const createMapping = (title: string, location: string[], type: string, group?: string) => ({
    title, location, type, group
})

const mapping = [
    createMapping('ID', ['id'], 'int', 'entity'),
    createMapping('Entity Name', ['name'], 'string', 'entity'),
    createMapping('Abbreviation', ['abbreviation'], 'string', 'entity'),
    createMapping('Location', ['location'], 'string', 'entity'),
    createMapping('Onboarding Date', ['onboardingDate'], 'string', 'entity'),
    createMapping('Domains', ['entityContext', 'domains'], 'json', 'context'),
    createMapping('Setup Status', ['_setupStatus'], 'string', 'health'),
]

export const EntityTable: React.FC<EntityTableProps> = ({ data, onEditClick, onCompleteSetupClick }) => {
    const tableData: any[][] = data.map((record: any) =>
        mapping.map((m) => ({
            title: m.title,
            value: utilService.getCellValue(record, m),
            type: m.type,
        }))
    )

    const handleEditClick = onEditClick ? (rowData: any[]) => {
        const idCell = rowData.find((cell: any) => cell.title === 'ID')
        const entityId = Number(idCell?.value)
        const rawItem = data.find((item: any) => Number(item.id) === entityId)
        if (rawItem) onEditClick(rawItem)
    } : undefined

    return (
        <GenericTable
            data={tableData}
            recordName="Entities"
            hiddenByDefault={['ID']}
            onEditClick={handleEditClick}
            editColumn="Entity Name"
            filterableColumns={['Entity Name', 'Location', 'Bucket Name']}
        />
    )
}

export default EntityTable
